import type { IconName } from '@frontend/icons';
import { WeavePopNotification } from '@frontend/types';
import { colorMap, type ColorMap } from './color-map';

export const colorNotificationTypeMap = {
  'sms-message-new': {
    color: 'tangerine',
    icon: 'message-unread-small',
  },
  'fax-new': {
    color: 'warning',
    icon: 'fax-small',
  },
  'fax-tag': {
    color: 'critical',
    icon: 'fax-small',
  },
  'call-record-tag': {
    color: 'critical',
    icon: 'label-small',
  },
  'chat-message-new': {
    color: 'indigo',
    icon: 'chat-small',
  },
  'review-new': {
    color: 'neutral',
    icon: 'star-small',
  },
  'schedule-request-new': {
    color: 'rose',
    icon: 'calendar-small',
  },
  'missed-call': {
    color: 'eggplant',
    icon: 'phone-missed-small',
  },
  'incoming-call': {
    color: 'eggplant',
    icon: 'phone-incoming-small',
  },
  'form-submission-new': {
    color: 'primary',
    icon: 'forms-small',
  },
  payments: {
    color: 'seaweed',
    icon: 'payments-small',
  },
  'task-center': {
    color: 'indigo',
    icon: 'task-small',
  },
  'voicemail-message': {
    color: 'eggplant',
    icon: 'voicemail-small',
  },
  'voicemail-tag': {
    color: 'critical',
    icon: 'label-small',
  },
  'message-followup': {
    color: 'indigo',
    icon: 'message-small',
  },
  'sms-tag': {
    color: 'critical',
    icon: 'label-small',
  },
  preference: {
    color: 'neutral',
    icon: 'settings-small',
  },
} satisfies Record<
  WeavePopNotification['type'],
  { color: keyof typeof colorMap; icon: Extract<IconName, `${string}-small`> }
>;

type ColorNotificationTypeMap = typeof colorNotificationTypeMap;

const generateNotificationPersonalizationMap = () => {
  return Object.keys(colorNotificationTypeMap).reduce(
    (acc, id) => {
      const notificationType = id as WeavePopNotification['type'];
      const { color, icon } = colorNotificationTypeMap[notificationType];
      acc[notificationType] = {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        color: colorMap[color],
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        icon,
      };

      return acc;
    },
    {} as {
      [K in WeavePopNotification['type']]: ColorNotificationTypeMap[K]['color'] extends keyof ColorMap
        ? { color: ColorMap[ColorNotificationTypeMap[K]['color']]; icon: ColorNotificationTypeMap[K]['icon'] }
        : never;
    }
  );
};

export const notificationPersonalizationMap = generateNotificationPersonalizationMap();
